import { Image, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import GuideImage1 from '@/assets/GuideImage1.png';
import GuideImage2 from '@/assets/GuideImage2.png';
import GuideImage3 from '@/assets/GuideImage3.png';
import GuideImage4 from '@/assets/GuideImage4.png';
import GuideImage5 from '@/assets/GuideImage5.png';
import { useTranslation } from 'react-i18next';
import { setIsShowSystemTour } from '@/store/modules/chatSlice.js';
import { useDispatch, useSelector } from 'react-redux';
import '../GuidePage.css';

const GuidePage = () => {
  const dispatch = useDispatch();
  const { isShowSystemTour } = useSelector(state => state.chat);
  const [autoPlay, setAutoPlay] = useState(true);
  const [resumeTimer, setResumeTimer] = useState(null);
  const { t } = useTranslation('home', 'translation');

  const images = [GuideImage1, GuideImage2, GuideImage3, GuideImage4, GuideImage5];
  const title = [
    t('home:descriptions.login.title'),
    t('home:descriptions.inputBox.title'),
    t('home:descriptions.DialogueResults.title'),
    t('home:descriptions.reportButton.title'),
    t('home:descriptions.report.title'),
  ];
  const description = [
    t('home:descriptions.login.description'),
    t('home:descriptions.inputBox.description'),
    t('home:descriptions.DialogueResults.description'),
    t('home:descriptions.reportButton.description'),
    t('home:descriptions.report.description'),
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(0);
  }, [isShowSystemTour]);

  useEffect(() => {
    if (!isShowSystemTour || !autoPlay) return;

    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [isShowSystemTour, images.length, autoPlay]);

  useEffect(() => {
    if (!isShowSystemTour && resumeTimer) {
      clearTimeout(resumeTimer);
    }
  }, [isShowSystemTour, resumeTimer]);

  const closeModal = () => {
    dispatch(setIsShowSystemTour(false));
  };

  const handleDotClick = index => {
    setCurrentIndex(index);
    setAutoPlay(false);

    if (resumeTimer) clearTimeout(resumeTimer);

    const timer = setTimeout(() => {
      setAutoPlay(true);
    }, 10000);

    setResumeTimer(timer);
  };

  return (
    <Modal open={isShowSystemTour} onCancel={closeModal} footer={null} centered width="70%">
      <div className="guide-container">
        <h1 className="guide-title">{t('home:guidePage')}</h1>
        <br />

        <div className="guide-image-wrapper">
          <Image
            alt="guide"
            src={images[currentIndex]}
            className="guide-image"
            preview={{ src: images[currentIndex] }}
          />
        </div>

        <p className="guide-step-title">{title[currentIndex]}</p>
        <p className="guide-step-description">{description[currentIndex]}</p>

        <div className="guide-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`guide-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default GuidePage;
